import { useState, useRef } from 'react';
// import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import {
  Typography,
  // FormGroup,
  // FormLabel,
  Grid,
  // CircularProgress,
  Box,
  // RadioGroup,
  // FormControlLabel,
  // Radio,
  // FormControl,
  // InputAdornment,
  // IconButton,
  useTheme,
  Container,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { CustomButton, MetaTags } from 'components/common';
// import  from '../common/CustomButton';
// import { Link, useHistory } from 'react-router-dom';
// import { ApiPostNoAuth } from 'helpers/Api/ApiData';
// import { InfoOutlined } from '@material-ui/icons';
// import { Visibility, VisibilityOff } from '@material-ui/icons';
// import {VisibilityIcon, VisibilityOff, ArrowBackIc} from '@mui/icons-material';
// import Visibility from '@mui/icons-material/Visibility';
// import VisibilityOff from '@mui/icons-material/VisibilityOff';
// import InfoOutlined from '@mui/icons-material/InfoOutlined';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import signinImg from 'assets/images/signin-img.svg';
import newsletterImg from 'assets/images/newsletter-img.svg';
// import CommonDescription from '../common/CommonDescription';
// import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import GoogleLogin from 'react-google-login';
// import Auth from 'helpers/auth';
import GoogleImage from 'assets/images/googleImg.png';
import { useRouter } from 'next/router';
import Link from 'components/Link';
import { useUser } from 'context/user.context';
import EmailSignup from 'components/signup/EmailSignup';
import GmailSignup from 'components/signup/GmailSignup';
import { useRedirectAuthorizedPaths } from 'hooks';

export default function Register() {
  const [, , setUser] = useUser();
  useRedirectAuthorizedPaths();

  const theme = useTheme();
  const useStyles = makeStyles({
    loginSignUpWrap: {
      // minHeight: "calc(100vh - 90px)",
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      WebkitFlexGrow: 1,
      '& MuiGrid-item': {
        width: '100%',
      },
      // [theme.breakpoints.down('sm')]:{
      //     minHeight: "calc(100vh - 256px)",
      // }
    },
    loginSignUpBox: {
      height: '100%',
      backgroundColor: '#fff',
      padding: '30px 30px',
      display: 'flex',
      // padding: "0px 22% 50px",
      borderRadius: 0,
      '& .MuiSvgIcon-root': {
        cursor: 'pointer',
      },
      // [theme.breakpoints.down('lg')]: {
      //     padding: "0px 15% 50px",
      // },
      // [theme.breakpoints.down('sm')]: {
      //     padding: "50px 15% 50px",
      // },

      // [theme.breakpoints.down('xs')]: {
      //     padding: "50px 10% 50px",
      // },

      '& h2': {
        marginBottom: 20,
        fontWeight: 500,
        fontSize: 20,
        lineHeight: 1,
        color: '#111111',
      },

      '& .MuiFormGroup-root': {
        marginBottom: 20,
      },

      '& .MuiFormLabel-root': {
        fontSize: 14,
        color: '#111111',
        lineHeight: 1.2,
        padding: 0,
      },
      '& .MuiInputLabel-outlined': {
        transform: 'translate(15px, 12px) scale(1)',
        [theme.breakpoints.down('xs')]: {
          transform: 'translate(15px, 15px) scale(1)',
        },
      },
      '& .MuiInputLabel-shrink': {
        transform: 'translate(15px, -8px) scale(1)',
        backgroundColor: '#fff',
        fontSize: 12,
        padding: '0 11px',
        color: 'rgba(17, 17, 17, 0.5)',
      },
      '& .MuiInputBase-formControl': {
        '& .MuiOutlinedInput-input': {
          padding: '12px 15px',
          fontSize: 14,
          [theme.breakpoints.down('xs')]: {
            fontSize: 14,
            padding: '15px 15px',
          },
        },
      },
      '& .MuiButton-root': {
        // width: '250px',
        borderRadius: 40,
        margin: '0px auto',

        '& span': {
          fontSize: 20,
          lineHeight: 1,
        },
      },
    },
    loginSignImg: {
      height: 'calc(100%)',
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'rgba(252, 252, 252, 0.5)',
      paddingTop: '90px',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    loginSignImg1: {
      // height: 'calc(100vh)',
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'rgba(252, 252, 252, 0.5)',
      paddingTop: '175px',

      '& img': {
        width: '60%',
        display: 'noone',
        margin: '0 auto 100px',
      },
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },

    loginSignImg2: {
      paddingTop: '100px',
      '& img': {
        width: '50%',
        display: 'none',
        margin: '0 auto 50px',
        [theme.breakpoints.down('md')]: {
          display: 'none',
        },
      },
    },
    forgotLink: {
      cursor: 'pointer',
      display: 'block',
      fontSize: 14,
      color: 'rgba(17, 17, 17, 0.7)',
      lineHeight: '19px',
      [theme.breakpoints.down('xs')]: {
        fontSize: 16,
      },
      '&:hover': {
        color: 'rgba(17, 17, 17, 1)',
      },
    },
    newRegister: {
      textAlign: 'center',
      fontSize: 14,
      color: '#111',
      fontWeight: 400,
      marginTop: -10,
      [theme.breakpoints.down('xs')]: {
        fontSize: 16,
      },
      '& a': {
        color: '#008b5e',
        fontWeight: 700,
      },
    },
    error: {
      fontSize: 12,
      lineHeight: 1,
      display: 'flex',
      // flexWrap: 'wrap',
      marginTop: 5,

      '& svg': {
        fontSize: 14,
        verticalAlign: 'middle',
        marginRight: 4,
      },
      '& .MuiInputBase-formControl': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: '#DD6161',
        },
      },
    },
    radioWant: {
      display: 'flex',
      flexDirection: 'row',
      marginBottom: 15,
      alignItems: 'center',

      '& .MuiFormLabel-root': {
        width: 100,
      },

      '& .MuiFormGroup-row': {
        marginBottom: 0,
        width: 'calc(100% - 100px)',
        [theme.breakpoints.down('sm')]: {
          width: 'calc(100% - 30px)',
        },
      },

      '& .MuiFormControlLabel-root': {
        marginRight: 40,
        [theme.breakpoints.down('xs')]: {
          marginRight: 30,
        },
      },

      '& .MuiFormControlLabel-label': {
        fontSize: 14,
        [theme.breakpoints.down('xs')]: {
          fontSize: 16,
        },
      },

      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
    },
    SignUpWelcome: {
      height: '100%',
      backgroundColor: '#fff',
      // padding: '45px 25% 0',
      // paddingRight: '25%',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignItems: 'center',

      // [theme.breakpoints.down('sm')]: {
      //   padding: '0px 15% 0',
      // },
      // [theme.breakpoints.down('xs')]: {
      //   padding: '0 10%',
      // },
    },
    SignUpWelcomeContent: {
      display: 'flex',
      flexWrap: 'wrap',

      '& h2': {
        width: '100%',
        display: 'block',
        fontWeight: 500,
        fontSize: 28,
        lineHeight: 1,
        color: '#111111',
        textAlign: 'center',
        margin: '54px 0 18px 0',
        [theme.breakpoints.down('xs')]: {
          marginTop: '50px',
        },
      },
      '& p': {
        display: 'block',
        fontWeight: 400,
        fontSize: 20,
        lineHeight: '28px',
        color: '#111111',
        textAlign: 'center',
      },
      '& span': {
        fontSize: '12px',
        textAlign: 'center',
        marginTop: '20px',
        lineHeight: '16px',
        padding: '10px 20px',
        color: 'rgba(17, 17, 17,0.5)',
      },
    },
    loginSignUpForm: {
      display: 'flex',
      width: '100%',
      maxWidth: 524,
      margin: '0 auto',
      '& .MuiSvgIcon-root': {
        cursor: 'pointer',
      },
      '& form': {
        width: '100%',
        display: 'block',
      },
    },

    ReferralCode: {
      '& .MuiInputBase-root': {
        '& input': {
          textTransform: 'uppercase',
          '&:disabled': {
            color: 'rgba(17, 17, 17,0.5)',
          },
        },
      },
    },
    passwordIcon: {
      verticalAlign: 'middle',
      marginRight: 4,
      '& svg': {
        fontSize: '1.5rem',
      },
    },
    firstNameTExtField: {
      '& .MuiFormControl-root': {
        marginBottom: '0px',
      },
      '& MuiBox-root': {
        marginTop: '0px',
      },
      [theme.breakpoints.down('xs')]: {
        marginBottom: '-4px !important',
      },
    },

    //Gmail Account
    gmailAccountWrap: {
      // minHeight: "calc(100vh - 90px)",
      display: 'flex',
      justifyContent: 'center',
      flex: 1,
      '& MuiGrid-item': {
        width: '100%',
      },
    },
    gmailSignImg: {
      height: 'calc(100%)',
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'rgba(252, 252, 252, 0.5)',
      paddingTop: '90px',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    signUpGmailBox: {
      height: '100%',
      backgroundColor: '#fff',
      padding: '49px 30px',
      // padding: "0px 22% 50px",
      borderRadius: 0,
      display: 'flex',
      alignItems: 'flex-start',
      //flexDirection: "column",
      [theme.breakpoints.down(767)]: {
        padding: '49px 15px',
        flexDirection: 'column',
      },
      '& .MuiSvgIcon-root': {
        cursor: 'pointer',
      },
      backIcon: {
        marginRight: '10px',
      },
      '& h2': {
        marginBottom: 20,
        fontWeight: 500,
        fontSize: 20,
        lineHeight: 1,
        color: '#111111',
      },
      '& .MuiButton-root': {
        width: '250px',
        borderRadius: 40,
        margin: '0px auto',

        '& span': {
          fontSize: 20,
          lineHeight: 1,
        },
      },
    },
    '& .MuiFormGroup-root': {
      marginBottom: 20,
    },

    '& .MuiFormLabel-root': {
      fontSize: 14,
      color: '#111111',
      lineHeight: 1.2,
      padding: 0,
    },
    '& .MuiInputLabel-outlined': {
      transform: 'translate(15px, 12px) scale(1)',
      [theme.breakpoints.down('xs')]: {
        transform: 'translate(15px, 15px) scale(1)',
      },
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(15px, -8px) scale(1)',
      backgroundColor: '#fff',
      fontSize: 12,
      padding: '0 11px',
      color: 'rgba(17, 17, 17, 0.5)',
    },
    '& .MuiInputBase-formControl': {
      '& .MuiOutlinedInput-input': {
        padding: '12px 15px',
        fontSize: 14,
        [theme.breakpoints.down('xs')]: {
          fontSize: 14,
          padding: '15px 15px',
        },
      },
    },
    signUpGmailForm: {
      display: 'block',
      width: '100%',
      maxWidth: 524,
      margin: '0 auto',
      heading: {
        display: 'flex',
      },
    },
    gmailRadioWant: {
      display: 'flex',
      flexDirection: 'row',
      marginBottom: 15,
      alignItems: 'center',

      '& .MuiFormLabel-root': {
        color: '#111111',
        width: 100,
        fontSize: 14,
      },

      '& .MuiFormGroup-row': {
        marginBottom: 0,
        [theme.breakpoints.down(767)]: {
          width: '100%',
        },
      },

      '& .MuiFormControlLabel-root': {
        marginRight: 40,
        [theme.breakpoints.down('xs')]: {
          marginRight: 30,
        },
      },

      '& .MuiFormControlLabel-label': {
        fontSize: 14,
        [theme.breakpoints.down('xs')]: {
          fontSize: 14,
        },
      },

      [theme.breakpoints.down(767)]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
    },
    mobileTextField: {
      marginBottom: '25px',
      '& .MuiInputLabel-outlined': {
        transform: 'translate(14px, 16px) scale(1)',
        fontSize: '14px',
      },
      '& .MuiInputBase-input': {
        padding: '12px 15px',
        fontSize: '14px',
      },
    },
    referrerTextField: {
      marginBottom: '51px',
      '& .MuiInputLabel-outlined': {
        transform: 'translate(14px, 16px) scale(1)',
        fontSize: '14px',
      },
      '& .MuiInputBase-input': {
        padding: '12px 15px',
        fontSize: '14px',
      },
    },
    gmailSignupButton: {
      alignItems: 'center',
      marginBottom: '27px',
      '& span': {
        fontSize: '24px',
        fontStyle: 'normal',
        fontWeight: 'bold',
      },
    },
    gmailNewRegister: {
      textAlign: 'center',
      fontSize: 14,
      color: '#111111',
      fontWeight: 400,
      //	marginTop: '40px',
      //	marginLeft: '35px',
      fontStyle: 'normal',
      [theme.breakpoints.down('xs')]: {
        fontSize: 16,
      },
      '& a': {
        color: '#008b5e',
        fontWeight: 700,
      },
    },

    //Two Button Account
    signUpAccountWrap: {
      //minHeight: "calc(100vh - 90px)",
      display: 'flex',
      justifyContent: 'center',
      flex: 1,
      '& MuiGrid-item': {
        width: '100%',
      },
    },
    signUpAccountBox: {
      height: '100%',
      backgroundColor: '#fff',
      padding: '30px',
      // padding: "0px 22% 50px",
      borderRadius: 0,
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap',
      alignItems: 'flex-start',
      justifyContent: 'center',
      textAlign: 'center',
      '& h2': {
        margin: '0 auto 20px',
        fontWeight: 500,
        fontSize: 28,
        lineHeight: 1,
        color: '#111111',
        [theme.breakpoints.down(767)]: {
          fontSize: '22px !important',
        },
      },
      '& .MuiButton-root': {
        // maxWidth: "280px",
        width: '100%',
        borderRadius: 40,
        // margin: '0px auto',

        '& span': {
          fontSize: 20,
          lineHeight: 1,
          [theme.breakpoints.down(360)]: {
            fontSize: 18,
          },
        },
      },
    },
    signUpAccountForm: {
      width: '100%',
      // maxWidth: 531,
      margin: '0 auto',
      '& h2': {
        fontSize: 24,
        fontStyle: 'normal',
        fontWeight: 500,
        textAlign: 'center',
        color: '#111111',
      },
    },
    signupAccountButton: {
      margin: '0px auto 0',

      '& button:first-child': {
        marginBottom: '17px',
        maxWidth: '280px',
        border: '1px solid transparent',
        '& span': {
          justifyContent: 'flex-start',
        },
      },
      '& button:last-child': {
        // minHeight: "64px",
        maxWidth: '280px',
        marginBottom: '32px',
      },
      '& small': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        backgroundColor: '#fff',
        width: '40px',
        height: '40px',
        marginRight: '8px',
        padding: '5px',
      },
    },

    newRegisterAccount: {
      textAlign: 'center',
      fontSize: 14,
      color: '#111',
      fontWeight: 400,
      margin: '0 auto',
      fontStyle: 'normal',
      [theme.breakpoints.down('xs')]: {
        fontSize: 16,
      },
      '& a': {
        color: '#008b5e',
        fontWeight: 700,
      },
    },
  });

  const classes = useStyles();
  const history = useRouter();
  //TODO: fix userTypeState
  // const userTypeState = history.location.state;
  const userTypeState = '1';
  // const referral = new URLSearchParams(props.location.search).get(
  //   'referral_code',
  // );
  const {
    handleSubmit,
    formState: { errors },
    control,
    watch,
  } = useForm({ mode: 'all' });
  const password = useRef({});
  password.current = watch('password', '');
  const [role_id, setRole_id] = useState<'1' | '2'>(userTypeState || '1');
  const [loader, setLoader] = useState(false);
  // const [passwordVisible, setPasswordVisible] = useState(false);
  // const [repeatPasswordVisible, setRepeatPasswordVisible] = useState(false);
  const [resisterSuccess, setResisterSuccess] = useState<any>();
  const [isEmailSignUp, setIsEmailSignUp] = useState(false);
  const [isGmailSignUp, setIsGmailSignUp] = useState(false);
  // const [redirectUrl, setRedirectUrl] = useState(null);
  // const [googleLoginResponse,setGoogleResponse]= useState();
  const [googleLoginResponse, setGoogleLoginResponse] = useState<any>();

  // useEffect(() => {
  //   const redirect_url = new URLSearchParams(history.location.search).get(
  //     'redirect_url',
  //   );
  //   setRedirectUrl(redirect_url);
  // }, [history]);

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, []);

  // const onSubmit = async (data: any) => {
  //   setLoader(true);
  //   data = {
  //     ...data,
  //     first_name: data.first_name.trim(),
  //     last_name: data.last_name.trim(),
  //     role_id: parseInt(role_id),
  //     referrer_code: data?.referrer_code?.toUpperCase().trim(),
  //   };
  //   console.log('data', data);
  //   ApiPostNoAuth(
  //     `${
  //       `user/signup`
  //       // redirectUrl
  //       //   ? `user/signup?redirect_url=${encodeURIComponent(redirectUrl)}`
  //       //   : `user/signup`
  //     }`,
  //     { ...data },
  //   )
  //     .then((res: any) => {
  //       if (res.data.statusCode === 200) {
  //         setResisterSuccess(res.data.data);
  //         setLoader(false);
  //       } else {
  //         toast.error(res.data.message, {
  //           autoClose: 5000,
  //           hideProgressBar: true,
  //         });
  //         setLoader(false);
  //       }
  //     })
  //     .catch((err: any) => {
  //       toast.error(err.message, { autoClose: 5000, hideProgressBar: true });
  //       setLoader(false);
  //     });
  // };

  // const validateName = async (name: any) => {
  //   const regex = /^[A-Za-z]+\s*$/i;
  //   if (!regex.test(name)) {
  //     return 'Invalid input';
  //   } else if (name.trim().length < 3) {
  //     return 'Please enter at least 3 characters';
  //   }
  // };

  // const validatePhone = async (e: any, onChange: any) => {
  //   // const regex = /^[0-9]{10}$/;
  //   const removeNonNumeric = (num: number | string) =>
  //     num.toString().replace(/[^0-9]/g, '');
  //   const formattedValue = removeNonNumeric(e.target.value);
  //   onChange(formattedValue);
  //   // if (amount) {
  //   //     return formattedValue
  //   // }
  // };
  const handleBack = () => {
    setIsGmailSignUp(false);
    setIsEmailSignUp(false);
  };
  const handleEmailSignUp = () => {
    setIsEmailSignUp(true);
  };
  const onGoogleSuccess = async (res: any) => {
    console.log('Login Success: currentUser: %j', res.profileObj);
    setGoogleLoginResponse(res.profileObj);
    setIsGmailSignUp(true);
    // const res = await ApiPostNoAuth(`user/socialLogin`, { ...res.profileObj, role_id })
    // alert(
    //   `Logged in successfully welcome ${res.profileObj.name} 😍. \n See console for full profile object.`
    // );
    // refreshTokenSetup(res);
  };
  // const onGoogleFailure = (res) => {
  // 	console.log('Login failed: res:', res);
  // 	alert(
  // 			`Failed to login. 😢 Please ping this to repo owner twitter.com/sivanesh_fiz`
  // 	);
  // };

  // const onSubmitGoogleRegister = async (data: any) => {
  //   try {
  //     setLoader(true);
  //     delete googleLoginResponse?.googleId;
  //     const res: any = await ApiPostNoAuth(`user/socialLogin`, {
  //       ...googleLoginResponse,
  //       role_id,
  //       ...data,
  //       referrer_code: data?.referrer_code?.toUpperCase().trim(),
  //       type: 'signup',
  //     });
  //     if (res.data.data !== null && res.data.statusCode === 200) {
  //       setLoader(false);
  //       const data = res.data.data;
  //       Auth.setAuthToken(data.token);
  //       if (data.user.role_id === 1) {
  //         // Auth.setUserData(res.data?.data?.user);
  //         setUser(res.data?.data?.user);
  //         // const redirect_url = new URLSearchParams(history.location.search).get(
  //         //   'redirect_url',
  //         // );
  //         // if (redirect_url) {
  //         //   window.location.replace(`${decodeURIComponent(redirect_url)}`);
  //         // } else {
  //         history.push('/startups');
  //         // }
  //         // isRedirectUrl(history, data.user.role_id, data.user.status, data.user.company);
  //         // history.push('/investor-assessment')
  //         // toast.success(res.data.message, { autoClose: 5000, hideProgressBar: true });
  //       } else if (data.user.role_id === 2) {
  //         // Auth.setUserData(res.data?.data?.user);
  //         setUser(res.data?.data?.user);

  //         history.push('/create-startup-profile');
  //         // toast.success(res.data.message, { autoClose: 5000, hideProgressBar: true });
  //       } else {
  //         toast.success('Admin cannot login', {
  //           autoClose: 5000,
  //           hideProgressBar: true,
  //         });
  //       }
  //     } else {
  //       toast.error(res.data.message, {
  //         autoClose: 5000,
  //         hideProgressBar: true,
  //       });
  //       setLoader(false);
  //     }
  //   } catch (error: any) {
  //     console.log(error);
  //     toast.error(error.message, { autoClose: 5000, hideProgressBar: true });
  //     setLoader(false);
  //   }
  // };

  return (
    <>
      <MetaTags
        title="Create new user account on POD"
        description="Become an investor through POD and start investing in promising early-stage startups."
        imageUrl={`${process.env.NEXT_PUBLIC_FRONTEND_URL}pod-logo.png`}
        url={process.env.NEXT_PUBLIC_FRONTEND_URL!}
        keywords="POD Register"
      />
      {/* <CommonDescription metaName="signUp" /> */}
      {!resisterSuccess ? (
        <div className={classes.loginSignUpWrap}>
          <>
            {isEmailSignUp ? (
              <EmailSignup
                handleBack={handleBack}
                setResisterSuccess={setResisterSuccess}
              />
            ) : (
              <>
                {isGmailSignUp ? (
                  <GmailSignup
                    handleBack={handleBack}
                    googleLoginResponse={googleLoginResponse}
                  />
                ) : (
                  <>
                    {/* {"show two button page"} */}
                    <div className={classes.signUpAccountWrap}>
                      <Grid container>
                        <Grid item xs={12} sm={12} md={6}>
                          <div className={classes.loginSignImg}>
                            <img src={signinImg.src} alt="signInImage" />
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <div className={classes.signUpAccountBox}>
                            <div className={classes.signUpAccountForm}>
                              <h2>Sign up to create an account </h2>
                            </div>
                            <div className={classes.signupAccountButton}>
                              <GoogleLogin
                                clientId={
                                  '335830995858-tbi0m6n9fmf8q4nlrr5o062ebg7a8vpq.apps.googleusercontent.com'
                                }
                                render={(renderProps) => (
                                  <CustomButton
                                    type="submit"
                                    sx={{
                                      fontSize: 20,
                                      width: 248,
                                      height: 50,
                                      mt: 2,
                                      mb: 3,
                                      background: '#4285F4',
                                      '&:hover': {
                                        backgroundColor: '#4285F4',
                                      },
                                      pl: 0,
                                    }}
                                    onClick={() => {
                                      renderProps.onClick();
                                    }}
                                    disabled={renderProps.disabled}
                                    // className="googleSignup"
                                  >
                                    <Box
                                      // className="googleIcon"
                                      component="small"
                                      sx={{
                                        // display: 'flex',
                                        alignItems: 'center',
                                        backgroundColor: '#fff',
                                        borderRadius: 50,
                                        height: '40px',
                                        width: '40px',
                                        mr: 1,
                                        '& img': {
                                          width: '100%',
                                          height: '100%',
                                          m: 'auto',
                                        },
                                        ml: -1,
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                      }}
                                    >
                                      {' '}
                                      <img src={GoogleImage.src} alt="" />
                                    </Box>
                                    Sign up with Google
                                  </CustomButton>
                                )}
                                buttonText=" Sign up with Google"
                                onSuccess={onGoogleSuccess}
                                // onFailure={onGoogleFailure}
                                cookiePolicy={'single_host_origin'}
                                style={{ marginTop: '100px' }}
                                // isSignedIn={true}
                              />
                              <CustomButton
                                disableRipple
                                disableFocusRipple
                                disableElevation
                                variant="outlined"
                                // type="submit"
                                // bgColor="#FFFFFF"
                                // bordercolor="#008b5e"
                                // fontColor="#008B5E"
                                // radius="0"
                                // btnPadding="15"
                                sx={{ fontSize: 20, width: 248, height: 50 }}
                                onClick={() => handleEmailSignUp()}
                              >
                                Sign up with Email
                              </CustomButton>
                            </div>
                            <div className={classes.newRegisterAccount}>
                              Already have an account?{' '}
                              <Link
                                sx={{ textDecoration: 'none' }}
                                // to={
                                //   redirectUrl
                                //     ? {
                                //         pathname: '/login',
                                //         search: `?redirect_url=${encodeURIComponent(
                                //           redirectUrl,
                                //         )}`,
                                //       }
                                //     : { pathname: '/login' }
                                // }
                                href="/login"
                              >
                                Login
                              </Link>
                            </div>
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  </>
                )}
              </>
            )}
          </>
        </div>
      ) : (
        <Container
          maxWidth="xl"
          sx={{
            flexGrow: 1,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Box
            flexBasis="50%"
            display="flex"
            justifyContent="center"
            sx={{ display: { xs: 'none', md: 'flex' } }}
          >
            <img src={newsletterImg.src} alt="signInImage" width={500} />
          </Box>
          {/* <Grid item md={6} justifyContent="center" alignItems="center"> */}
          {/* <div className={classes.loginSignImg1}> */}
          {/* </div> */}
          {/* </Grid> */}
          <Box
            flexBasis="50%"
            display="flex"
            justifyContent="center"
            flexGrow={1}
          >
            <div className={classes.SignUpWelcome}>
              <Box
                className={classes.SignUpWelcomeContent}
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                  px: {
                    xs: 0,
                    sm: 0,
                    lg: 20,
                    xl: 30,
                  },
                }}
              >
                <div className={classes.loginSignImg2}>
                  <img src={newsletterImg.src} alt="signInImage" />
                </div>
                <h2>Welcome to Pod</h2>
                <Typography component="p" align="center">
                  Hi {resisterSuccess?.first_name}, an email has been sent to{' '}
                  {resisterSuccess?.email}. Please confirm it to proceed
                  further.
                </Typography>
                <span>
                  Note: If you don&apos;t receive the confirmation email within
                  a few minutes of signing up, please check your Spam or Bulk
                  E-Mail folder.
                </span>
              </Box>
            </div>
          </Box>
        </Container>
      )}

      {/* <CommonSwitchDashboard /> */}
    </>
  );
}
